import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["data-test-value"]
const _hoisted_2 = {
  class: "cursor-pointer relative",
  "data-testid": "authControl"
}
const _hoisted_3 = { class: "relative cursor-default" }
const _hoisted_4 = {
  key: 0,
  class: "absolute right-0 top-2 bg-tile rounded-lg text-neutral2-500 border border-tile-border shadow-md px-4 py-2"
}

import {computed, ref, watch} from "vue";
import {NavigationUser} from "../../../../../Domain/Navigation/NavigationUser";
import {useClickOutside} from "../../../Helper/clickOutside";
import {useNavigationStore} from "../navigationStore";
import {authControlItems} from "../Presenter/authControlItems";
import {useNavigationService} from "../vue";
import DesktopMenuListItem from "./ListItem/DesktopMenuListItem.vue";
import UserAvatar from "./UserAvatar.vue";

interface Props {
  user: NavigationUser|null;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'DesktopAuthControl',
  props: {
    user: {}
  },
  setup(__props: any) {

const store = useNavigationStore();

const props = __props;

const controlOpen = ref<boolean>(false);

function toggleControl(): void {
  controlOpen.value = !controlOpen.value;
}

function closeControl(): void {
  controlOpen.value = false;
}

const clickOutside = useClickOutside(false);

watch(controlOpen, (newValue: boolean): void => {
  if (newValue) {
    clickOutside.addClickListener(closeControl);
  } else {
    clickOutside.removeAll();
  }
});

const service = useNavigationService();

const _authControlItems = computed(() => authControlItems(
  props.user,
  store.$state.darkTheme,
));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("span", {
      class: "hidden",
      "data-testid": "authenticationState",
      "data-test-value": props.user ? 'loggedIn' : 'guest'
    }, null, 8 /* PROPS */, _hoisted_1),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(UserAvatar, {
        user: props.user,
        onClick: toggleControl
      }, null, 8 /* PROPS */, ["user"]),
      _createElementVNode("div", _hoisted_3, [
        (controlOpen.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_authControlItems.value, (listItem) => {
                return (_openBlock(), _createBlock(DesktopMenuListItem, {
                  type: listItem.type,
                  title: listItem.title,
                  icon: listItem.icon,
                  "messages-count": listItem.messagesCount,
                  action: listItem.action,
                  onAction: _cache[0] || (_cache[0] = action => _unref(service).action(action))
                }, null, 8 /* PROPS */, ["type", "title", "icon", "messages-count", "action"]))
              }), 256 /* UNKEYED_FRAGMENT */))
            ]))
          : _createCommentVNode("v-if", true)
      ])
    ])
  ]))
}
}

})